﻿import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationSv from "../Assets/i18n/sv/translation.json";
import translationEn from "../Assets/i18n/en/translation.json";


const language = document.documentElement.lang;

const resources = {
    sv: {
        translation: translationSv,
    },
    en: {
        translation: translationEn,
    }
}

i18n.use(initReactI18next).init({
    lng: language, // if you're using a language detector, do not define the lng option
    resources,
    fallbackLng: 'en'
});

export default i18n;
